module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "title-chapter"
  }, [_c('a', {
    attrs: {
      "href": "#/e9781429975346_toc01#toctitle1",
      "id": "title1"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("1")])])])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("I")]), _vm._v(" recall this particular married woman I’d had a short fling with when I was in my mid-twenties. I’d met her at the opening of an art exhibit in downtown San Diego in the Gaslamp Quarter; she was thirty-four and her name was Barbara. She was one of the would-be dancer-painter types that always seemed to be friends with my ex-girlfriend, Elaine. I’d actually gone to the exhibit at the Rita Dear Gallery hoping to spark something up with Elaine again, as we occasionally did, being off-and-on for the past several years. I was immediately drawn to Barbara—her pale skin and dark hair, her lithe body. She wasn’t wearing a ring and I didn’t know she was married until Elaine said, “We have to meet Barbara’s husband and some friends at this restaurant at eight, you should come.” As with all gallery openings, there was plenty of wine, and someone brought out spiked punch, and vodka Jell-O. Barbara quickly got drunk; as we talked, she kept leaning into me and touching my arm, and then my chest. Someone put on loud music. As I tried to have a conversation with Barbara, she leaned over and said into my ear, her tongue touching my flesh, “The music is too loud, let’s talk outside.” We went outside. She pointed to a Toyota Camry and said, “That’s my car,” and the next thing I knew, we were in the back of her car and necking. It was pretty intense. She stopped, a hand on my chest. “I can’t do this,” she said, “I’m married.”")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("“Okay.”")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("“And Elaine and I are late. My husband’s going to worry.”")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("“You’re all right.”")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("“Not to drive.”")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("“The restaurant isn’t far. Walk.”")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("“Come with us,” she said.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("“I don’t think so.”")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("“Please,” she said.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("I said, “All right.”")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("I walked Elaine and Barbara to the restaurant. It was eight-thirty but her husband—a thick man in a suit-didn’t seem worried, didn’t seem to notice the time. He was deep in conversation with several other men and women in suits, talking about bonds and securities and real estate.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("I felt uncomfortable, observing Barbara kiss her husband lightly on the lips, hanging onto his thick arm.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("They ordered dinner.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("After one drink, I left—abruptly. I said there was something I forgot to attend to. Barbara gave me a look I didn’t understand. I didn’t want to understand it.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("I lived in a downtown studio a few blocks away: I, the starving law student. I went home, turned on the TV. I was sad.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("An hour later: a knock on my door.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Barbara, still drunk, came right in. She smelled nice.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("“I have twenty, maybe thirty minutes,” she said. Her eyes were glassy. “My husband and I took separate cars, I’m sure you know. But if I don’t get home in time, he’ll worry.”")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("I was flabbergasted. “How did you know where I lived?”")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("“Elaine told me—”")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("“She—”")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("“Doesn’t have a clue,” Barbara said. The woman didn’t waste any time; she pulled me to her and kissed me. We quickly undressed and went to my futon.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("“Look,” she said. “I want you to know I’ve never done anything like this, "), _c('em', {
    staticClass: "i"
  }, [_vm._v("ever")]), _vm._v(". I’ve never had an affair.”")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("“Never?”")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("“Ten years of marriage, never.”")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("“Your husband?”")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("“I don’t think so.”")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("“You love him?”")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("“Very much.”")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("“So why—”")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("“Don′t ask why,” Barbara said, “just screw me, okay?”")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("She wasn’t my first married woman, and not my last. I’d heard all the excuses for infidelity since I was nineteen and had discovered the sad and sexual world of married women.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Barbara and I fucked twice in an hour and a half of loss, bliss, and body parts—clearly well over her time limit.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("“It’s late,” she said, her head on my chest.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("“Will he be waiting?”")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("“He probably went straight to bed, like he always does. He won’t notice.”")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("“He trusts you.”")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("“He just doesn’t notice. I should go,” but she didn’t move.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("I said, “Stay.”")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("She sat up, looking for her clothes. “That I can’t do.”")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("I watched her slip her panties and bra on, then her black jeans and gray vest. I felt hollow.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("I saw her to the door.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("“Bye,” she said.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("I grabbed her arm. She smiled. I said, “Hey.” I kissed her. It was a ten-minute kiss.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("“Hey, boy,” she said.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("“Back to bed?” I said.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("“I’m scared,” she said, “I’m married,” and she pushed me away, and she ran.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("I think I understood what she was going through.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Well, if I didn’t then, I do now.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b5878858","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781429975346_c01.vue
// module id = 72
// module chunks = 0